import React, { useState, useEffect } from "react";
import ReactView from "./kommentareView";
import { Hola, KommentareInfo } from "../interfaces";
import {
  createComment,
  getCommentById,
  getCommentsBySong,
  updateComment,
} from "../api";

interface KommentareInterface {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  data: Hola[];
  aktuelLied: number;
  level: string;
  specificAudio: string;
  setReload?: React.Dispatch<React.SetStateAction<boolean>>;
  kommentarrolle: string;
  kommentarId?: string;
}

const Kommentare: React.FC<KommentareInterface> = ({
  openModal,
  setOpenModal,
  data,
  aktuelLied,
  level,
  specificAudio,
  setReload,
  kommentarrolle,
  kommentarId,
}) => {
  const [kommentareData, setKommentareData] = useState<KommentareInfo[]>([]);
  const [kommentareById, setKommentareById] = useState<KommentareInfo[]>([]);

  const firstProtection =
    kommentareById[0] === undefined ? "" : kommentareById[0].name;
  const nameById = firstProtection !== undefined ? firstProtection : "";
  const firstProtectionDescription =
    kommentareById[0] === undefined ? "" : kommentareById[0].description;
  const descriptionById =
    firstProtectionDescription !== undefined ? firstProtectionDescription : "";
  const [kommentare, setKommentare] = useState({
    id_lied: aktuelLied || undefined,
    name: nameById,
    description: descriptionById,
    audio_id: specificAudio,
  });

  const sendKommentar = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const { name, value } = e.target;
    e.preventDefault();

    setKommentare((prevKommentare) => ({
      ...prevKommentare,
      [name]: value,
      id_lied: aktuelLied,
      audio_id: specificAudio,
    }));
  };

  const getKommentarById = async () => {
    try {
      const data = await getCommentById(kommentarId ? kommentarId : "");
      setKommentare((information) => ({
        ...information,
        name: data[0] === undefined ? "" : data[0].name || "",
        description: data[0] === undefined ? "" : data[0].description || "",
      }));
    } catch (error) {
      return console.log({
        message: "der einzige Kommentar ist nicht erreicht worden",
        error,
      });
    }
  };

  const updateDataFuntion = async () => {
    if (setReload) {
      setReload(true);
    }
    try {
      if (kommentarrolle === "erschaffen") {
        await createComment(kommentare);
      } else if (kommentarrolle === "bearbeiten") {
        await updateComment(kommentarId ? kommentarId : "", kommentare);
      }
    } catch (error) {
      console.log({ message: "error al crear un comentario" });
    }

    if (setReload) {
      setReload(false);
    }
  };

  const getKommentare = async () => {
    try {
      const information = await getCommentsBySong(aktuelLied);
      if (level === "normal") {
        return setKommentareData(information as KommentareInfo[]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    await event.preventDefault();
    await updateDataFuntion();
    await getKommentare();
  };

  useEffect(() => {
    getKommentare();
  }, [aktuelLied]);

  useEffect(() => {
    if (kommentarrolle === "bearbeiten") {
      getKommentarById();
    }
  }, [kommentarId]);

  return (
    <ReactView
      openModal={openModal}
      setOpenModal={setOpenModal}
      sendKommentar={sendKommentar}
      handleSubmit={handleSubmit}
      kommentare={kommentare}
      level={level}
      kommentareData={kommentareData}
      specificAudio={specificAudio}
      setKommentare={setKommentare}
      kommentarrolle={kommentarrolle}
      kommentareById={kommentareById}
    />
  );
};

export default Kommentare;
